import api from './http';

// Publications multi-espaces
export const listPublications = (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return api.get(`/publications${qs ? `?${qs}` : ''}`);
};
export const getPublication = (id) => api.get(`/publications/${id}`);
export const getPublicationRecipientOptions = (params = {}) => api.get(`/publications/recipient-options?${new URLSearchParams(params)}`, { timeout: 15000 });
export const createPublication = (data) => api.post('/publications', data, { timeout: 30000 });
export const createPublicationsBulk = (data) => api.post('/publications/bulk', data, { timeout: 120000 });
export const updatePublication = (id, data) => api.patch(`/publications/${id}`, data, { timeout: 30000 });
export const deletePublication = (id) => api.delete(`/publications/${id}`);
export const uploadPublicationMedia = (file, kind = 'photo') => {
  const fd = new FormData();
  fd.append('file', file);
  fd.append('kind', kind);
  return api.post('/publications/upload-media', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
};
export const acceptPublicationRecipient = (pubId, recipientId) =>
  api.post(`/publications/${pubId}/recipients/${recipientId}/accept`);
export const declinePublicationRecipient = (pubId, recipientId) =>
  api.post(`/publications/${pubId}/recipients/${recipientId}/decline`);
export const publicationMediaUrl = (objectPath) =>
  `${process.env.REACT_APP_BACKEND_URL}/api/publications/media/${objectPath}`;

// Portail
export const portalListPublications = () => api.get('/portal/publications');
export const portalMarkPublicationRead = (id) => api.post(`/portal/publications/${id}/read`);
export const portalReservePublication = (id) => api.post(`/portal/publications/${id}/reserve`);
export const portalDeclinePublication = (id) => api.post(`/portal/publications/${id}/decline`);
